var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#20252F;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1000,2000c552.3,0,1000-447.7,1000-1000C2000,447.7,1552.3,0,1000,0C447.7,0,0,447.7,0,1000 C0,1552.3,447.7,2000,1000,2000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1634.5,615.6h-212.1L1324.6,935h209.2L1634.5,615.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1253.8,1166.3l-104.5-247c-11.7-30.5-32.3-56.7-59.1-75.3s-58.7-28.5-91.4-28.5c-32.3,0-63.9,9.6-90.6,27.8 c-26.7,18.1-47.4,43.9-59.3,73.9l-108.7,248.6L574.3,615.9H365.6l247.9,806.7c4.6,14.8,13.8,27.7,26.2,36.8 c12.4,9.2,27.5,14.1,42.9,14.1h119.9c14.5,0.1,28.8-4.1,40.9-12.2c12.1-8.1,21.5-19.6,26.9-33L998.8,1112l130.6,317.3 c5.4,13.4,14.7,24.8,26.7,32.8c12,8.1,26,12.4,40.5,12.4h118c15.4,0,30.4-4.9,42.8-14.1c12.4-9.1,21.6-22,26.2-36.7l117.7-382.2 H1293L1253.8,1166.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoo);
export default __webpack_public_path__ + "static/media/woo.7dee9de7372c6761474493d7f07aad81.svg";
export { ForwardRef as ReactComponent };